"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Upload = _interopRequireDefault(require("../Icons/Upload"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var getAccepted = function getAccepted(accepted) {
  var len = accepted.length;
  var accept = accepted.map(function (a, i) {
    var type = a.type ? a.type : '';
    type += a.extension ? "/".concat(a.extension) : '/*';
    type += i !== len - 1 ? ', ' : '';
    return type;
  }).join(' ');
  return accept;
};

var counter = 0;

function dragEnter(e, setFile) {
  counter++;
  setFile(true);
  e.preventDefault();
}

function dragLeave(e, setFile) {
  counter--;
  counter === 0 && setFile(false);
  e.preventDefault();
}

function dragOver(e) {
  e.preventDefault();
  e.dataTransfer.dropEffect = 'move';
}

function dropFile(e, setFile, onClick, multiple) {
  e.preventDefault();
  e.stopPropagation();
  var files = multiple ? e.dataTransfer.files : [e.dataTransfer.files[0]];
  onClick(files);
  setFile(false);
  counter = 0;
}

var validateFiles = function validateFiles(files, validFileTypes) {
  var _iterator = _createForOfIteratorHelper(files),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var f = _step.value;
      var type = f.type.split('/')[1];
      if (!validFileTypes.includes(type)) return false;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
};

var UploadField = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var icon = _ref.icon,
      name = _ref.name,
      multiple = _ref.multiple,
      onClick = _ref.onClick,
      supported = _ref.supported,
      label = _ref.label,
      errorText = _ref.errorText,
      otherProps = _objectWithoutProperties(_ref, ["icon", "name", "multiple", "onClick", "supported", "label", "errorText"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      withFile = _useState2[0],
      setWithFile = _useState2[1];

  var handleChange = function handleChange(_ref2) {
    var target = _ref2.target;
    var fileTypes = supported.map(function (s) {
      return s.extension;
    });
    var extensionsOk = validateFiles(target.files, fileTypes);
    if (supported && supported.length && !extensionsOk) return alert(errorText);
    onClick(target.files);
  };

  return /*#__PURE__*/_react.default.createElement(StyledButton, _extends({
    withFile: withFile,
    onClick: onClick,
    onDragEnter: function onDragEnter(e) {
      return dragEnter(e, setWithFile);
    },
    onDragLeave: function onDragLeave(e) {
      return dragLeave(e, setWithFile);
    },
    onDragOver: dragOver,
    onDrop: function onDrop(e) {
      return dropFile(e, setWithFile, onClick, multiple);
    }
  }, otherProps), icon, withFile ? 'Drop file to upload' : label, /*#__PURE__*/_react.default.createElement("input", {
    accept: supported.length ? getAccepted(supported) : '*',
    ref: ref,
    type: "file",
    name: name,
    multiple: multiple,
    onChange: handleChange
  }));
});

var StyledButton = _styledComponents.default.label.withConfig({
  displayName: "StyledButton"
})(["font-family:", ";font-size:1.6rem;line-height:120%;border-radius:0.5rem;min-width:14rem;width:", ";padding:2vh 0;border:0.5px solid;border-color:", ";box-sizing:border-box;border-radius:5px;display:flex;flex-direction:column;justify-content:center;align-items:center;color:", ";&:hover{cursor:pointer;input,svg{cursor:pointer;}}background-color:", ";position:relative;svg{margin-bottom:12px;path{fill:", ";}}input{position:absolute;opacity:0;}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, function (_ref4) {
  var fullwidth = _ref4.fullwidth;
  return fullwidth ? '100%' : '52vw';
}, function (_ref5) {
  var withFile = _ref5.withFile,
      theme = _ref5.theme;
  return withFile ? theme.brand.secondary : theme.ui.outline;
}, function (_ref6) {
  var withFile = _ref6.withFile,
      theme = _ref6.theme;
  return withFile ? theme.brand.secondary : theme.typo.highlight;
}, function (_ref7) {
  var withFile = _ref7.withFile,
      theme = _ref7.theme;
  return withFile ? theme.ui.active : theme.ui.background;
}, function (_ref8) {
  var withFile = _ref8.withFile,
      theme = _ref8.theme;
  return withFile ? theme.brand.secondary : theme.ui.interactive;
});

StyledButton.displayName = 'StyledButton';
UploadField.displayName = 'UploadField';
UploadField.defaultProps = {
  multiple: false,
  icon: /*#__PURE__*/_react.default.createElement(_Upload.default, null),
  name: 'label',
  label: 'Click here or drag file to upload',
  otherProps: {},
  supported: [],
  fullwidth: false,
  errorText: 'File error!'
};
UploadField.propTypes = {
  fullwidth: _propTypes.bool,
  icon: _propTypes.element,
  name: _propTypes.string.isRequired,
  multiple: _propTypes.bool,
  onClick: _propTypes.func.isRequired,
  supported: _propTypes.array,
  label: _propTypes.string,
  errorText: _propTypes.string,
  otherProps: _propTypes.object
};
var _default = UploadField;
exports.default = _default;